import React, { useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Chip, TextField, Typography } from "@material-ui/core";

const ExternalBadge = () => (
  <Chip
    label="Externo"
    size="small"
    style={{
      marginLeft: 8,
      height: 20,
      fontSize: 11,
      fontWeight: 500,
      backgroundColor: "#e3f2fd",
      color: "#1565c0",
    }}
  />
);

const Select = ({
  id,
  options = [],
  value,
  setValue,
  label,
  disabled = false,
  error = false,
  required = false,
  multiple = false,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState();
  const [valueInternal, setValueInternal] = useState();

  useEffect(() => {
    setValueInternal(value);
  }, [value]);

  return (
    <Autocomplete
      id={id}
      options={options}
      autoComplete={false}
      getOptionLabel={(option) => option.name || ""}
      renderOption={(option) => (
        <Typography component="span" style={{ display: "flex", alignItems: "center" }}>
          {option.name}
          {option.isExternal && <ExternalBadge />}
        </Typography>
      )}
      value={valueInternal || (multiple ? [] : "")}
      onChange={(event, newValue) => {
        setValue(newValue);
        setValueInternal(newValue);
      }}
      inputValue={inputValue || ""}
      onInputChange={(event, newInputValue, prop) => {
        setInputValue(newInputValue);
      }}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          name={id}
          id={id}
          label={label}
          fullWidth
          error={error}
          required={required}
          {...rest}
        />
      )}
      multiple={multiple}
      {...rest}
    />
  );
};

export { Select, ExternalBadge };
